import request from '@/utils/request'

export async function getsetting(data) {
  return request({
    url: '/getsetting',
    method: 'get'
  })
}
export async function updatesetting(data) {
    const result = await request({
        url: '/updatesetting',
        method: 'put',
        data: data
    })
    return result.data
}
export async function addsetting(data) {
    const result = await request({
        url: '/addsetting',
        method: 'put',
        data: data
    })
    return result.data
}
